import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const ThemeCase = (props) => {
    const [result, setResult] = useState([]);

    useEffect(() => {
        setResult(props.fields);
    });

    const RenderCase = () => {
        return (
            <React.Fragment>
                <h3 className="theme__case--title text__color--white">
                    {result.selectcase_link.post_title}
                </h3>
                <div className="theme__btnholder">
                    <Link
                        className="cta-btn white"
                        to={`/work/${result.selectcase_link.post_name}`}>
                        View case
                    </Link>
                    <Link className="cta-btn white" to="/work">
                        More Cases
                    </Link>
                </div>
            </React.Fragment>
        );
    };

    return (
        <React.Fragment>
            {result.selectcase_link && (
                <div className="theme__case fadeIn">
                    <div className="content-container">
                        <div className="theme__case--inner">
                            <span className="theme__case--tagline text__color--white">
                                Selected case
                            </span>
                            <RenderCase />
                        </div>
                    </div>
                    <div className="theme__case--shadow fadeIn"></div>
                    <img
                        src={
                            result.selectcase_image &&
                            result.selectcase_image.sizes.img_overview_wide
                        }
                        className="fadeIn"
                        alt="slide"
                    />
                </div>
            )}
        </React.Fragment>
    );
};

export default ThemeCase;



// WEBPACK FOOTER //
// ./src/components/Pages/Themes/ThemeCase.jsx